import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  Box,
  Button,
  Chip,
  Container,
  IconButton,
  Paper,
  Typography,
} from "@mui/material";
import Slider from "react-slick";
import dayjs from "dayjs";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import EventIcon from "@mui/icons-material/Event";
import TodayIcon from "@mui/icons-material/Today";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import CloseIcon from "@mui/icons-material/Close";
import PersonIcon from "@mui/icons-material/Person";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import omekaImg from "../../assets/scheduleIcons/omeka.png";
import mapImg from "../../assets/scheduleIcons/arcgis.png";
import aiImg from "../../assets/scheduleIcons/ai.jpeg";
import twineImg from "../../assets/scheduleIcons/twine.jpg";
import mdlImg from "../../assets/scheduleIcons/mdl.webp";
import digitizationImg from "../../assets/scheduleIcons/digitize.jpg";
import archiveImg from "../../assets/scheduleIcons/archive.jpg";
import lunchImg from "../../assets/scheduleIcons/lunch.png";
import audioImg from "../../assets/scheduleIcons/audio.jpeg";
import videoImg from "../../assets/scheduleIcons/videoedit.png";
import codeImg from "../../assets/scheduleIcons/code.png";
import proposalImg from "../../assets/scheduleIcons/assignmentr.png";
import presentationImg from "../../assets/scheduleIcons/Presentation.avif";
import tripImg from "../../assets/scheduleIcons/trip.jpg";
import housingImg from "../../assets/scheduleIcons/housing.jpeg";
import tourImg from "../../assets/scheduleIcons/tour.webp";
import photoImg from "../../assets/scheduleIcons/photo.svg";
import thankyouImg from "../../assets/scheduleIcons/thankyou.jpg";
import sendoffImg from "../../assets/scheduleIcons/sendoff.png";
import freeImg from "../../assets/scheduleIcons/free.png";
import defaultImg from "../../assets/scheduleIcons/omeka.png";
import orientationImg from "../../assets/scheduleIcons/orientation.png";
import itechImg from "../../assets/scheduleIcons/itech.jpeg";
import researchImg from "../../assets/scheduleIcons/research.jpg";
import researchconceptsImg from "../../assets/scheduleIcons/researchconcepts.png";
import julyImg from "../../assets/scheduleIcons/july4.webp";
import campImg from "../../assets/scheduleIcons/campshelby.png";
import qImg from "../../assets/scheduleIcons/Q&A.jpg";
import digitalImg from "../../assets/scheduleIcons/digitalproject.png";
import timelineImg from "../../assets/scheduleIcons/timeline.png";
import pocketmuseumImg from "../../assets/scheduleIcons/pocketmuseum.webp";
import digitalstoryImg from "../../assets/scheduleIcons/digitalstory.png";
import analyzeImg from "../../assets/scheduleIcons/analyze.png";
import wordpressImg from "../../assets/scheduleIcons/wordpress.png";
import labImg from "../../assets/scheduleIcons/labtime.jpg";
import museumImg from "../../assets/scheduleIcons/museum.jpg";
import freetimeImg from "../../assets/scheduleIcons/freetime.png";
import qgisImg from "../../assets/scheduleIcons/qgis.jpeg";
import oneononeImg from "../../assets/scheduleIcons/oneonone.jpg";
import scanImg from "../../assets/scheduleIcons/3dscanner.jpg";
import reviewImg from "../../assets/scheduleIcons/review.webp";
import discussionImg from "../../assets/scheduleIcons/discussion.jpg";
import pitchImg from "../../assets/scheduleIcons/pitch.jpg";
import funtimeImg from "../../assets/scheduleIcons/funtime.png";
const scheduleData = [
  {
    date: "2026-06-15",
    events: [
      {
        time: "10:00 AM - 12:00 PM",
        title: "Check-in for Housing",
        description: "-",
        location: "",
        type: "",
        instructor: "-",
      },
      {
        time: "12:00 PM - 1:30 PM",
        title: "Catered Lunch - University Catering",
        description: "-",
        location: "",
        type: "",
        instructor: "-",
      },
      {
        time: "1:30 PM - 3:30 PM",
        title: "Campus Tour",
        description: "-",
        location: "",
        type: "",
        instructor: "-",
      },
      {
        time: "3:30 PM - 5:00 PM",
        title: "Campus Services Orientation / Welcome from Dr. Haley",
        description: "-",
        location: "",
        type: "",
        instructor: "Dr. Andrew Haley",
      },
      {
        time: "6:00 PM",
        title: "Group Dinner - Petra Cafe",
        description: "Group dinner.",
        location: "Petra Cafe, Hattiesburg, MS",
        locationUrl: "https://petracafe.net/",
        type: "meal",
        instructor: "-",
      },
    ],
  },
  {
    date: "2026-06-16",
    events: [
      {
        time: "9:00 AM - 10:30 AM",
        title: "iTech / Library Set Up",
        description:
          "Participants will get their devices and accounts configured for the tools and platforms used throughout the residency, including access to library databases and digital project software. This is an essential first step to ensure everyone is ready to hit the ground running.",
        location: "",
        type: "",
        instructor: "-",
      },
      {
        time: "10:30 AM - 12:00 PM",
        title:
          "Introduction to Residency Activities, Assignments, and Final Project",
        description:
          "An overview of what participants can expect over the six weeks, including the weekly reading and portfolio expectations and the shape of the final project. This session sets the tone and helps participants understand how each week builds toward a finished piece of digital scholarship.",
        location: "Liberal Arts Building 205",
        type: "",
        instructor: "Hub Staff",
      },
      {
        time: "12:00 PM - 1:00 PM",
        title: "Lunch Break",
        description: "-",
        location: "",
        type: "",
        instructor: "-",
      },
      {
        time: "1:00 PM - 2:00 PM",
        title: "Introduction to Research and Research Questions",
        description:
          "Participants will learn how to develop focused, researchable questions and navigate the curated LibGuide built to support the residency. This session lays the methodological foundation for working with primary sources and scholarly literature throughout the program.",
        location: "Cook Library",
        locationUrl:
          "https://www.google.com/maps/place/Joseph+Anderson+Cook+Memorial+Library/@31.3273189,-89.3368964,17z/data=!4m10!1m2!2m1!1scook+library+usm!3m6!1s0x889cde97adf22995:0x776bf5f12c8a9227!8m2!3d31.3273352!4d-89.3343101!15sChBjb29rIGxpYnJhcnkgdXNtWhIiEGNvb2sgbGlicmFyeSB1c22SARJ1bml2ZXJzaXR5X2xpYnJhcnmaASNDaFpEU1VoTk1HOW5TMFZKUTBGblNVTnViRFpVYUVwbkVBReABAPoBBAgAEC0!16s%2Fg%2F11gbk5c0b3?entry=ttu&g_ep=EgoyMDI2MDYwMy4xIKXMDSoASAFQAw%3D%3D",
        type: "",
        instructor: "Tisha Zelner",
      },
      {
        time: "2:15 PM - 4:30 PM",
        title: "Introduction to Special Collections",
        description:
          "An introduction to USM's Special Collections with guidance on how to browse, evaluate, and select archival items as the basis for a digital project. Participants will begin thinking about which materials resonate with their emerging research interests.",
        location: "McCain Library",
        locationUrl:
          "https://www.google.com/maps/place/McCain+Library+and+Archives/@31.3263624,-89.3369262,17z/data=!3m1!4b1!4m6!3m5!1s0x889cde970162da01:0x2f84983743ffc5de!8m2!3d31.3263578!4d-89.3343513!16s%2Fm%2F04f5kft?entry=ttu&g_ep=EgoyMDI2MDYwMy4xIKXMDSoASAFQAw%3D%3D",
        type: "",
        instructor: "Jennifer Brannock",
      },
      {
        time: "4:30 PM - 5:00 PM",
        title: "Q&A / Wrap-up",
        description: "-",
        location: "",
        type: "",
        instructor: "-",
      },
    ],
  },
  {
    date: "2026-06-17",
    events: [
      {
        time: "9:00 AM - 10:00 AM",
        title: "Introduction to Digital Projects and Scholarship",
        description:
          "This session introduces what digital humanities scholarship actually looks like in practice. We will explore how it differs from traditional academic writing and what makes a digital project a form of scholarly argument. Participants will explore a range of examples to build a shared vocabulary for the weeks ahead.",
        location: "Liberal Arts Building 205",
        type: "",
        instructor: "Hub Staff",
      },
      {
        time: "10:30 AM - 12:00 PM",
        title: "Reading and Analyzing Digital Scholarship",
        description:
          "Participants will develop skills for critically evaluating digital projects, learning to ask questions about design choices, argument, audience, and methodology. This session treats DH projects as texts to be read and interpreted.",
        location: "",
        type: "",
        instructor: "Dr. Jennifer Andrella",
      },
      {
        time: "12:00 PM - 1:00 PM",
        title: "Lunch Break",
        description: "-",
        location: "",
        type: "",
        instructor: "-",
      },
      {
        time: "1:00 PM - 2:00 PM",
        title: "Creating a Digital Portfolio Site in WordPress",
        description:
          "Participants will set up the personal digital portfolio that will serve as their ongoing record of learning throughout the residency. The session covers basic site structure, customization, and how portfolio entries will connect to weekly readings and activities.",
        location: "Liberal Arts Building 205",
        type: "",
        instructor: "Hub Staff",
      },
      {
        time: "2:00 PM - 4:30 PM",
        title: "Lab / Work Time",
        description: "-",
        location: "",
        type: "",
        instructor: "Hub Staff",
      },
    ],
  },
  {
    date: "2026-06-18",
    events: [
      {
        time: "9:00 AM - 10:00 AM",
        title: "Special Collections Sharing and Reflection Session",
        description:
          "Participants share the items they found most interesting or promising during their Special Collections visit, practicing the skill of articulating why a particular artifact has research potential. This conversation-based session helps the cohort learn from each other's instincts and observations.",
        location: "Liberal Arts Building 205",
        type: "",
        instructor: "Hub Staff",
      },
      {
        time: "10:30 AM - 12:00 PM",
        title: "Processes of Creating Digital Scholarship from the Archives",
        description:
          "Dr. Haley walks participants through what it looks like to move from an archival discovery to a finished piece of digital scholarship, drawing on his own experience as a historian. This session bridges the gap between raw primary sources and the interpretive work of building a project.",
        location: "Liberal Arts Building 205",
        type: "",
        instructor: "Dr. Andrew Haley",
      },
      {
        time: "12:00 PM - 1:00 PM",
        title: "Lunch Break",
        description: "-",
        location: "",
        type: "",
        instructor: "-",
      },
      {
        time: "1:00 PM - 1:30 PM",
        title:
          "How to Search and Handle Special Collection Items (& paperwork)",
        description:
          "A practical session on the protocols and care involved in working with fragile or rare archival materials, including any necessary paperwork for reproduction or digitization. Participants will leave prepared to work responsibly and efficiently with the collections.",
        location: "McCain Library",
        locationUrl:
          "https://www.google.com/maps/place/McCain+Library+and+Archives/@31.3263624,-89.3369262,17z/data=!3m1!4b1!4m6!3m5!1s0x889cde970162da01:0x2f84983743ffc5de!8m2!3d31.3263578!4d-89.3343513!16s%2Fm%2F04f5kft?entry=ttu&g_ep=EgoyMDI2MDYwMy4xIKXMDSoASAFQAw%3D%3D",

        type: "",
        instructor: "Jennifer Brannock",
      },
      {
        time: "1:30 PM - 4:00 PM",
        title: "Selection of Items from Collections",
        description:
          "Participants will continue to select items relevant to their research question and interests from a selection of materials curated by the special collections staff. The cohort will leave this session with items ready to digitize and form a scholarly foundation for their research and project development over the next four weeks.",
        location: "McCain Library",
        locationUrl:
          "https://www.google.com/maps/place/McCain+Library+and+Archives/@31.3263624,-89.3369262,17z/data=!3m1!4b1!4m6!3m5!1s0x889cde970162da01:0x2f84983743ffc5de!8m2!3d31.3263578!4d-89.3343513!16s%2Fm%2F04f5kft?entry=ttu&g_ep=EgoyMDI2MDYwMy4xIKXMDSoASAFQAw%3D%3D",

        type: "",
        instructor: "Jennifer Brannock",
      },
    ],
  },
  {
    date: "2026-06-19",
    events: [
      {
        time: "9:00 AM - 9:30 AM",
        title: "Morning Check-in",
        description: "-",
        location: "",
        type: "",
        instructor: "-",
      },
      {
        time: "9:30 AM - 12:00 PM",
        title: "Visit to Hattiesburg Museums",
        description:
          " In observance of Juneteenth, participants will visit local museums that reflect the history and culture of the Hattiesburg community. This outing connects the themes of digital preservation and storytelling to living local history.",
        location: "",
        type: "",
        instructor: "-",
      },
      {
        time: "1:00 PM - 3:00 PM",
        title: "Transcription Lab (Tentative)",
        description:
          "Participants will practice transcribing handwritten or difficult-to-read archival documents, a foundational skill for making historical materials accessible and searchable online. Transcription also deepens close engagement with primary sources in ways that photocopying alone cannot.",
        location: "",
        type: "",
        instructor: "-",
      },
      {
        time: "3:00 PM - 4:30 PM",
        title: "Free Time / Community Activity",
        description: "-",
        location: "",
        type: "",
        instructor: "-",
      },
    ],
  },
  {
    date: "2026-06-20",
    events: [
      {
        time: "All Day",
        title: "Coastal Trip",
        description:
          "What We'll Explore | 🏛️ Ohr-O'Keefe Museum of Art | 🛍️ Downtown Ocean Springs & Farmers Market | 🍽️ By the Fig & the Olive | 🏛️ Walter Anderson Museum of Art | ☕ The Traveler Coffee Shop | 🏖️ Ocean Springs Beach | 🍕 Pizza Dinner by the Coast",
        location: "Ocean Springs, MS",
        locationUrl:
          "https://www.google.com/maps/search/?api=1&query=Ocean+Springs+MS",
        type: "trip",
        instructor: "-",
      },
    ],
  },
  {
    date: "2026-06-21",
    events: [
      {
        time: "All Day",
        title: "Day Off",
        description: "-",
        location: "",
        type: "",
        instructor: "-",
      },
    ],
  },
  {
    date: "2026-06-22",
    events: [
      {
        time: "9:00 AM - 10:00 AM",
        title:
          'Inaugural "Brunch Brag : Southbound Bagel" — Ideas for Projects from Special Collections Items and Items of Note',
        description:
          " A low-stakes, conversational session where participants share the archival items they've been most excited by and sketch out early project ideas. This peer-sharing format encourages creative thinking and helps people refine their concepts through community feedback.",
        location: "Liberal Arts Building 205",
        type: "",
        instructor: "Hub Staff",
      },
      {
        time: "10:00 AM - 12:00 PM",
        title:
          "DH Showcase — Projects Utilizing Special Collections and Bibliographies",
        description:
          "Participants will examine finished digital projects built from archival materials similar to what they're working with, discussing what makes them effective and what they might do differently. This showcase provides concrete models and inspiration as participants begin narrowing their own project directions.",
        location: "",
        type: "",
        instructor: "Hub Staff",
      },
      {
        time: "12:00 PM - 1:00 PM",
        title: "Lunch Break",
        description: "-",
        location: "",
        type: "",
        instructor: "-",
      },
      {
        time: "1:00 PM - 2:30 PM",
        title: "Narrative / Interactive Storytelling in Games: Twine",
        description:
          "An introduction to Twine, a free tool for creating branching, choose-your-own-adventure style narratives. Participants will explore how interactive storytelling can be a powerful mode for presenting historical or research-based content to public audiences.",
        location: "Liberal Arts Building 205",
        type: "",
        instructor: "Dr. Craig Carey",
      },
      {
        time: "2:30 PM - 4:30 PM",
        title: "Lab / Work Time",
        description: "-",
        location: "",
        type: "",
        instructor: "Hub Staff",
      },
    ],
  },
  {
    date: "2026-06-23",
    events: [
      {
        time: "9:00 AM - 10:30 AM",
        title: "Introduction to MDL",
        description:
          "Participants will learn how the Mississippi Digital Library aggregates and preserves digital collections across the state and what standards and workflows govern quality digitization. This session situates participants' own digitization work within a broader ecosystem of public digital memory.",
        location: "",
        type: "",
        instructor: "Hannah Dean and Austin Slade",
      },
      {
        time: "10:30 AM - 12:00 PM",
        title: "Hands on Digitizing Materials with DigiLab Equipment",
        description:
          "A practical lab session where participants use professional scanning and photography equipment to create high-quality digital surrogates of their chosen archival items. This hands-on time is essential for producing the digital assets final projects will be built around.",
        location: "",
        type: "",
        instructor: "Hannah Dean and Austin Slade",
      },
      {
        time: "12:00 PM - 1:00 PM",
        title: "Lunch Break",
        description: "-",
        location: "",
        type: "",
        instructor: "-",
      },
      {
        time: "1:30 PM - 3:30 PM",
        title: "Dear Mr. Meredith Project",
        description:
          "Guests from the University of Mississippi Libraries will present their work on the Dear Mr. Meredith Project, a digital humanities initiative centered on community letters and civil rights history. This case study illustrates how archives can be transformed into publicly engaged digital scholarship.",
        location: "Liberal Arts Building 205",
        type: "",
        instructor: "Abbie Norris and/or Adam Clemons",
      },
      {
        time: "3:30 PM - 4:30 PM",
        title: "Lab / Work Time / Digitization",
        description: "-",
        location: "",
        type: "",
        instructor: "Hub Staff",
      },
      {
        time: "5:00 PM - 7:00 PM",
        title: "Dinner with Abbie Norris and Adam Clemons",
        description: "Group dinner",
        location: "Jutamas Thai, Timothy Lane, Hattiesburg, MS",
        locationUrl: "https://jutamasthaims.com/",
        instructor: "-",
      },
    ],
  },
  {
    date: "2026-06-24",
    events: [
      {
        time: "9:00 AM - 12:00 PM",
        title: "Return to DigiLab for Digitization Time",
        description: "-",
        location: "",
        type: "",
        instructor: "Hub Staff",
      },
      {
        time: "12:00 PM - 1:00 PM",
        title: "Lunch Break",
        description: "",
        location: "",
        type: "",
        instructor: "-",
      },
      {
        time: "1:00 PM - 3:00 PM",
        title: "Introduction to ArcGIS Story Maps and Flourish",
        description:
          "Participants will be introduced to two accessible data visualization and storytelling platforms: ArcGIS StoryMaps for mapping-based narratives and Flourish for interactive charts and infographics. The session covers how and why to use each tool, with hands-on experimentation.",
        location: "Liberal Arts Building 205",
        type: "",
        instructor: "Riley Houston",
      },
      {
        time: "3:30 PM - 4:30 PM",
        title: "Lab / Work Time",
        description: "-",
        location: "",
        type: "",
        instructor: "-",
      },
    ],
  },
  {
    date: "2026-06-25",
    events: [
      {
        time: "9:00 AM - 10:00 AM",
        title: "Systems, Artificial Intelligence, and the Humanities",
        description:
          "TBD, potentially a focus on chat bot creation and hands-on time in beginning the process of building a usable chat bot through AI tools.",
        location: "Liberal Arts Building 205",
        type: "",
        instructor: "Avantika Mittapally",
      },
      {
        time: "10:30 AM - 12:00 PM",
        title: "Introduction to QGIS",
        description:
          "An introduction to QGIS, a free and open-source geographic information system that allows users to map, analyze, and visualize spatial data. Participants will learn the basics of loading layers, working with coordinates, and thinking geographically about their research topics.",
        location: "Liberal Arts Building 205",
        type: "",
        instructor: "Dr. Kayla Stan",
      },
      {
        time: "12:00 PM - 1:00 PM",
        title: "Lunch Break",
        description: "-",
        location: "",
        type: "",
        instructor: "-",
      },
      {
        time: "1:00 PM - 4:30 PM",
        title: "QGIS Continued / Lab Time",
        description: "-",
        location: "Liberal Arts Building 205",
        type: "",
        instructor: "Kayla Stan",
      },
    ],
  },
  {
    date: "2026-06-26",
    events: [
      {
        time: "9:00 AM - 12:00 PM",
        title: "Datasets and QGIS Projects",
        description: "-",
        location: "Liberal Arts Building 205",
        type: "",
        instructor: "Kayla Stan",
      },
      {
        time: "12:00 PM - 1:00 PM",
        title: "Lunch Break",
        description: "-",
        location: "",
        type: "",
        instructor: "-",
      },
      {
        time: "1:30 PM - 3:30 PM",
        title: "TBD",
        description: "-",
        location: "Liberal Arts Building 205",
        type: "",
        instructor: "-",
      },
      {
        time: "3:30 PM - 4:30 PM",
        title: "Lab / Work Time",
        description: "-",
        location: "Liberal Arts Building 205",
        type: "",
        instructor: "Hub Staff",
      },
      {
        time: "5:00 PM - 6:30 PM",
        title:
          "Optional Visit to Payne Center for Viewing of Automated Submersibles",
        description:
          "An optional behind-the-scenes look at robotics and underwater vehicle technology developed at USM, connecting digital humanities to the broader landscape of technology innovation on campus. This visit offers a chance to see how computational tools are used in fields far beyond the humanities.",
        location: "Payne Center",
        locationUrl: "https://maps.app.goo.gl/FuX38QAg5ZEA3i4N7",
        type: "",
        instructor: "Hub Staff",
      },
    ],
  },
  {
    date: "2026-06-27",
    events: [
      {
        time: "All Day",
        title: "Day Trip to Natchez",
        description:
          "What We'll Explore | 🏺 Grand Village of the Natchez Indians | 🍽️ Lunch at The Guest House | 🏠 Longwood House | 📜 William Johnson House | 🏛️ Melrose Historic Site | 🚗 Forks of the Road, Richard Wright House & Riverwalk | 🌮 Dinner at Fat Mama's Tamales",
        location: "Natchez, MS",
        locationUrl:
          "https://www.google.com/maps/search/?api=1&query=Natchez+MS",
        type: "trip",
        instructor: "-",
      },
    ],
  },
  {
    date: "2026-06-28",
    events: [
      {
        time: "All Day",
        title: "Day Off / Steel Magnolias on Campus",
        description: "-",
        location: "",
        type: "",
        instructor: "-",
      },
    ],
  },
  {
    date: "2026-06-29",
    events: [
      {
        time: "9:00 AM - 10:00 AM",
        title: '"Brunch Brag - Vicious Biscuit" from QGIS Work',
        description: "-",
        location: "Liberal Arts Building 205 - Break room",
        type: "",
        instructor: "Hub Staff",
      },
      {
        time: "10:00 AM - 11:00 AM",
        title: "Introduce Project Proposal Assignment",
        description:
          "Participants will receive the formal guidelines for their project proposals, which will map out the argument, audience, tools, and sources for their final DH project. This session marks a key transition from exploration to intentional project development.",
        location: "Liberal Arts Building 205",
        type: "",
        instructor: "Hub Staff",
      },
      {
        time: "11:00 AM - 12:00 PM",
        title:
          "Research and Writing Lab: Scholarship / Brainstorming / Topic Mapping",
        description:
          "Dedicated time to dig into secondary literature, brainstorm project angles, and create visual maps of how topics, sources, and arguments connect. The goal is to move from loose ideas to a more structured sense of what a finished project might look like.",
        location: "Liberal Arts Building 205",
        type: "",
        instructor: "Hub Staff",
      },
      {
        time: "12:00 PM - 1:00 PM",
        title: "Lunch Break",
        description: "-",
        location: "",
        type: "",
        instructor: "-",
      },
      {
        time: "1:00 PM - 2:30 PM",
        title: "Introduction to Digital Exhibits — Showcase",
        description:
          "Participants will explore examples of online digital exhibits to understand how curatorial decisions, metadata, and design work together to communicate meaning. This prepares them to think like exhibit-builders as they move into hands-on work with Omeka.",
        location: "Liberal Arts Building 205",
        type: "",
        instructor: "Hub Staff",
      },
      {
        time: "2:30 PM - 4:30 PM",
        title: "Lab / Work Time",
        description: "-",
        location: "Liberal Arts Building 205",
        type: "",
        instructor: "-",
      },
    ],
  },
  {
    date: "2026-06-30",
    events: [
      {
        time: "9:00 AM - 12:00 PM",
        title: "Guided Practice with Omeka",
        description:
          "KC New from Mississippi State University Libraries leads participants through Omeka, an open-source platform widely used for building digital archives and exhibits. Participants will learn how to upload items, write metadata, and begin organizing collections into a navigable online exhibit.",
        location: "Liberal Arts Building 205",
        type: "",
        instructor: "KC New",
      },
      {
        time: "12:00 PM - 1:00 PM",
        title: "Lunch Break",
        description: "-",
        location: "",
        type: "",
        instructor: "-",
      },
      {
        time: "1:00 PM - 4:30 PM",
        title: "Continued Omeka Practice / Lab Time",
        description: "-",
        location: "Liberal Arts Building 205",
        type: "",
        instructor: "KC New",
      },
    ],
  },
  {
    date: "2026-07-01",
    events: [
      {
        time: "9:00 AM - 12:00 PM",
        title: "Guided Practice with Omeka (Continued)",
        description: "-",
        location: "Liberal Arts Building 205",
        type: "",
        instructor: "KC New",
      },
      {
        time: "12:00 PM - 1:00 PM",
        title: "Lunch Break",
        description: "-",
        location: "",
        type: "",
        instructor: "-",
      },
      {
        time: "1:00 PM - 2:00 PM",
        title: "Workshop on Omeka Plugins (If Necessary)",
        description:
          " A focused session on extending Omeka's functionality through plugins that enable features like mapping, timelines, and enhanced exhibit layouts. Participants will learn which plugins are most useful for their project types and how to implement them. Dedicated time will be spent especially on the Neatline plugin and testing its capabilities and limitations.",
        location: "Liberal Arts Building 205",
        type: "",
        instructor: "Dr. Andrew McSorley",
      },
      {
        time: "2:30 PM - 4:30 PM",
        title: "Lab / Work Time",
        description: "",
        location: "Liberal Arts Building 205",
        type: "",
        instructor: "-",
      },
    ],
  },
  {
    date: "2026-07-02",
    events: [
      {
        time: "9:00 AM - 10:00 AM",
        title: "Lab Morning: Project Building with Omeka",
        description: "-",
        location: "Liberal Arts Building 205",
        type: "",
        instructor: "Hub Staff",
      },
      {
        time: "10:00 AM - 12:00 PM",
        title:
          "Artificial Intelligence in the Humanities / Literature and Readings Roundtable / Digital Archives",
        description:
          "A discussion-based session exploring how AI is being debated, applied, and critiqued within humanities fields, drawing on assigned readings and recent examples from digital archives and literary scholarship. Participants will have the chance to voice their own perspectives in a structured roundtable format.",
        location: "Liberal Arts Building 205",
        type: "",
        instructor: "Hub Staff",
      },
      {
        time: "12:00 PM - 1:00 PM",
        title: "Lunch Break",
        description: "-",
        location: "",
        type: "",
        instructor: "-",
      },
      {
        time: "1:00 PM - 3:00 PM",
        title: "Research Concepts and Scholarly Argumentation",
        description:
          "This session focuses on how to construct a clear scholarly argument supported by primary and secondary sources, with attention to what makes DH projects persuasive and intellectually credible. Working in the library reinforces the connection between research practice and the physical and digital collections that support it.",
        location: "Liberal Arts Building 205",
        type: "",
        instructor: "Hub Staff",
      },
      {
        time: "3:00 PM - 4:30 PM",
        title: "Lab / Work Time",
        description: "-",
        location: "Liberal Arts Building 205",
        type: "",
        instructor: "-",
      },
      {
        time: "6:00 PM",
        title: "Group Dinner - Tabella",
        description: "Group dinner",
        location: "Tabella, Hattiesburg, MS",
        locationUrl: "https://tabellapronto.com/",
        type: "meal",
        instructor: "-",
      },
    ],
  },
  {
    date: "2026-07-03",
    events: [
      {
        time: "9:00 AM - 11:00 AM",
        title: "Visit to Robotics Lab",
        description:
          "Participants will tour USM's Robotics Lab for an up-close look at how computer science intersects with engineering, automation, and real-world problem-solving. This visit broadens participants' understanding of computational thinking and its applications.",
        location: "",
        type: "",
        instructor: "Dr. Jose Martinez",
      },
      {
        time: "11:30 AM - 12:00 PM",
        title: "Project Proposals Due — Submission and Review",
        description: "-",
        location: "Liberal Arts Building 205",
        type: "",
        instructor: "Hub Staff",
      },
      {
        time: "12:00 PM onward",
        title: "July 4th Activities / Free Afternoon",
        description: "-",
        location: "",
        type: "",
        instructor: "-",
      },
    ],
  },
  {
    date: "2026-07-04",
    events: [
      {
        time: "All Day",
        title: "Fireworks / July 4th Hattiesburg Activities",
        description: "-",
        location: "",
        type: "",
        instructor: "-",
      },
    ],
  },
  {
    date: "2026-07-05",
    events: [
      {
        time: "All Day",
        title: "Day Off",
        description: "-",
        location: "",
        type: "",
        instructor: "-",
      },
    ],
  },
  {
    date: "2026-07-06",
    events: [
      {
        time: "9:00 AM - 10:00 AM",
        title: '"Brunch Brag - McAlisters Deli" from Omeka Building',
        description: "-",
        location: "Liberal Arts Building 205 - Break room",
        type: "",
        instructor: "Hub Staff",
      },
      {
        time: "10:00 AM - 12:00 PM",
        title:
          "DH Tool Review / Project Review — Brief presentations on project proposals",
        description:
          "Participants give short presentations on their project proposals, receiving feedback from peers and instructors on their chosen tools, arguments, and source materials. This low-stakes presentation experience builds the communication skills they'll need for the final showcase.",
        location: "Liberal Arts Building 205",
        type: "",
        instructor: "Hub Staff",
      },
      {
        time: "12:00 PM - 1:00 PM",
        title: "Lunch Break",
        description: "-",
        location: "",
        type: "",
        instructor: "-",
      },
      {
        time: "1:00 PM - 4:30 PM",
        title:
          "Additional Time for Digitization / Special Collections / Lab Work",
        description: "-",
        location: "Liberal Arts Building 205",
        type: "",
        instructor: "-",
      },
    ],
  },
  {
    date: "2026-07-07",
    events: [
      {
        time: "8:30 AM - 4:30 PM",
        title: "Camp Shelby Visit Day",
        description:
          "A full-day field trip to Camp Shelby and auxiliary spaces surrounding the Mississippi Armed Forces Museum, exploring how military history is preserved, displayed, and interpreted for public audiences. This visit offers a rich case study in institutional memory, community heritage, and the challenges of telling complex historical stories. (Please note, entrance to Camp Shelby requires a valid government-issued ID card)",
        location: "",
        type: "",
        instructor: "Amanda Wade and Tommy Lofton",
      },
    ],
  },
  {
    date: "2026-07-08",
    events: [
      {
        time: "9:00 AM - 12:00 PM",
        title:
          "One-on-Ones: Project Proposals, Research, and Tool Recommendations",
        description:
          "Individual check-in meetings with program staff to review each participant's project progress, troubleshoot research challenges, and get personalized recommendations for tools and approaches. These sessions ensure that every participant has a viable, well-supported path to a finished project.",
        location: "Liberal Arts Building 205",
        type: "",
        instructor: "Hub Staff",
      },
      {
        time: "12:00 PM - 1:00 PM",
        title: "Lunch Break",
        description: "-",
        location: "",
        type: "",
        instructor: "-",
      },
      {
        time: "1:00 PM - 3:00 PM",
        title: "Continue One-on-one Meetings",
        description: "-",
        location: "Liberal Arts Building 205",
        type: "",
        instructor: "-",
      },
      {
        time: "3:30 PM - 4:30 PM",
        title: "Photogrammetry and 3D Scanning / 3D Printing Demo",
        description:
          "An introduction to photogrammetry, a technique that uses overlapping photographs to generate 3D models of physical objects. Participants will see how historians are using this technology to create digital surrogates of artifacts that can be shared, examined, and preserved in three dimensions.",
        location: "Liberal Arts Building 205",
        type: "",
        instructor: "Dr. Courtney Luckhardt",
      },
    ],
  },
  {
    date: "2026-07-09",
    events: [
      {
        time: "9:00 AM - 10:00 AM",
        title: "Review of LibGuide and Searching for Primary Sources",
        description: "-",
        location: "Liberal Arts Building 205",
        type: "",
        instructor: "-",
      },
      {
        time: "10:00 AM - 12:00 PM",
        title: "The Story of Archives and Mississippi History",
        description:
          "Potentially focusing on Mississippi history, archival practice, and digital humanities, with a focus on how regional and state-level archives hold stories that national narratives often overlook.",
        location: "Liberal Arts Building 205",
        type: "",
        instructor: "C.T. Salazar",
      },
      {
        time: "12:00 PM - 1:00 PM",
        title: "Lunch Break",
        description: "-",
        location: "",
        type: "",
        instructor: "-",
      },
      {
        time: "1:30 PM - 4:30 PM",
        title:
          "Lab Day: Building with Data Sets and Public Data from Mississippi Government and Institutions",
        description:
          "Participants will work with publicly available datasets from Mississippi government agencies and institutions to explore how open data can serve as raw material for DH projects.",
        location: "Liberal Arts Building 205",
        type: "",
        instructor: "Hub Staff",
      },
      {
        time: "6:00 PM",
        title: "Group Dinner - Big Trouble",
        description: "Group dinner.",
        location: "Big Trouble, Hattiesburg, MS",
        locationUrl: "https://www.eatbigtrouble.com/",
        type: "meal",
        instructor: "-",
      },
    ],
  },
  {
    date: "2026-07-10",
    events: [
      {
        time: "9:00 AM - 10:00 AM",
        title: "AI and DH Readings Discussion",
        description:
          "A focused discussion on the week's assigned readings about artificial intelligence and digital humanities, encouraging participants to apply theoretical frameworks to the tools and projects they've been building. This session develops the critical vocabulary participants will need to write and speak about their work in scholarly contexts.",
        location: "Liberal Arts Building 205",
        type: "",
        instructor: "Hub Staff",
      },
      {
        time: "10:30 AM - 12:00 PM",
        title:
          "State of the DH / Library Profession and the Academy / Showcase of Graduate Programs and Professional Opportunities",
        description:
          "An honest look at the current landscape of digital humanities as a field, including job markets, graduate programs, and the evolving role of libraries in supporting digital scholarship. This session helps participants begin thinking strategically about how DH skills fit into their academic and professional futures.",
        location: "Liberal Arts Building 205",
        type: "",
        instructor: "Hub Staff",
      },
      {
        time: "12:00 PM - 1:00 PM",
        title: "Lunch Break",
        description: "-",
        location: "",
        type: "",
        instructor: "-",
      },
      {
        time: "1:00 PM - 4:30 PM",
        title: "Library and Research Time",
        description: "-",
        location: "Liberal Arts Building 205",
        type: "",
        instructor: "-",
      },
    ],
  },
  {
    date: "2026-07-11",
    events: [
      {
        time: "All Day",
        title: "Day Off",
        description: "-",
        location: "",
        type: "",
        instructor: "-",
      },
    ],
  },
  {
    date: "2026-07-12",
    events: [
      {
        time: "Weekend Option",
        title: "Downtown Hattiesburg and Pocket Museum",
        description: "-",
        location: "",
        type: "",
        instructor: "-",
      },
    ],
  },
  {
    date: "2026-07-13",
    events: [
      {
        time: "9:00 AM - 10:00 AM",
        title: '"Brunch Brag - Loblolly Bakery" from Mapping Work',
        description: "-",
        location: "",
        type: "",
        instructor: "-",
      },
      {
        time: "10:00 AM - 12:00 PM",
        title: "Across the Storytelling Spectrum: Showcase",
        description:
          "A curated showcase of digital storytelling projects that span a range of formats, platforms, and audiences—from academic digital editions to public-facing multimedia narratives. This session opens a conversation about how choices of medium and form shape what stories can be told and who can access them.",
        location: "Liberal Arts Building 205",
        type: "",
        instructor: "-",
      },
      {
        time: "12:00 PM - 1:00 PM",
        title: "Lunch Break",
        description: "-",
        location: "",
        type: "",
        instructor: "-",
      },
      {
        time: "1:00 PM - 4:30 PM",
        title: "Lab / Work Time",
        description: "-",
        location: "Liberal Arts Building 205",
        type: "",
        instructor: "-",
      },
    ],
  },
  {
    date: "2026-07-14",
    events: [
      {
        time: "9:00 AM - 10:00 AM",
        title: "Audio Storytelling: Showcase",
        description:
          "Participants explore examples of podcasts, oral history recordings, and audio documentaries to understand how sound-based storytelling operates differently from text or image-based work. This prepares them for the hands-on audio production session that follows.",
        location: "Liberal Arts Building 205",
        type: "",
        instructor: "Hub Staff",
      },
      {
        time: "10:00 AM - 12:00 PM",
        title: "Recording and Editing with Audacity",
        description:
          "Drawing on USM's rich oral history tradition, Ross Walton guides participants through the practical skills of recording clean audio and editing it into a coherent narrative. Participants will learn both the technical craft and the ethical considerations involved in working with spoken voices and personal testimony.",
        location: "Liberal Arts Building 205",
        type: "",
        instructor: "Ross Walton",
      },
      {
        time: "12:00 PM - 1:00 PM",
        title: "Lunch Break",
        description: "-",
        location: "",
        type: "",
        instructor: "-",
      },
      {
        time: "1:00 PM - 3:30 PM",
        title: "Cohort Interviews Assignment",
        description:
          "Participants interview one another using the skills developed in the audio session, creating a collective record of the cohort's experiences and perspectives as well as preserving descriptions of their research interests and project goals. This assignment doubles as a community-building activity and a practical exercise in applied oral history methodology.",
        location: "Liberal Arts Building 205",
        type: "",
        instructor: "",
      },
      {
        time: "3:30 PM - 4:30 PM",
        title: "Lab / Work Time / Interview Submission",
        description: "-",
        location: "Liberal Arts Building 205",
        type: "",
        instructor: "Hub Staff",
      },
    ],
  },
  {
    date: "2026-07-15",
    events: [
      {
        time: "9:00 AM - 10:30 AM",
        title: "Content is King — Video Creation and Editing: Showcase",
        description:
          "A showcase of video-based digital projects, from documentary shorts to explainer videos, illustrating how moving image and audio can combine to create compelling scholarly and public-facing content. Participants discuss what makes video an effective medium for certain kinds of arguments and stories.",
        location: "Liberal Arts Building 205",
        type: "",
        instructor: "-",
      },
      {
        time: "11:00 AM - 12:00 PM",
        title: "Creating and Editing Video Narratives with Canva",
        description:
          "A hands-on introduction to video editing using Canva, with a focus on combining footage, text, images, and sound into a polished short narrative. Participants will learn efficient workflows for non-linear editing with no professional software required.",
        location: "Liberal Arts Building 205",
        type: "",
        instructor: "Dr. Andrew McSorley",
      },
      {
        time: "12:00 PM - 1:00 PM",
        title: "Lunch Break",
        description: "-",
        location: "",
        type: "",
        instructor: "-",
      },
      {
        time: "1:00 PM - 3:30 PM",
        title: 'Final Project "Trailer" Assignment',
        description:
          " Participants create a short video trailer that previews their final project, distilling their argument and key materials into a compelling, accessible format. This assignment pushes participants to think clearly about what is most essential and exciting about their work.",
        location: "Liberal Arts Building 205",
        type: "",
        instructor: "-",
      },
      {
        time: "3:30 PM - 4:30 PM",
        title: "Lab / Work Time / Trailer Submission",
        description: "-",
        location: "Liberal Arts Building 205",
        type: "",
        instructor: "-",
      },
    ],
  },
  {
    date: "2026-07-16",
    events: [
      {
        time: "9:00 AM - 11:00 AM",
        title:
          "Creating Communities, Connecting Local to Global through Digital Stories",
        description:
          "TBD – Potentially a presentation on how the Walter Anderson Museum and related projects use digital tools to bring an artist's vision and legacy to new audiences.",
        location: "Liberal Arts Building 205",
        type: "",
        instructor: "Julian Rankin",
      },
      {
        time: "11:00 AM - 12:00 PM",
        title:
          "Digital Tools of Witness and Journalism: Storymaps JS and Timeline JS",
        description:
          "An introduction to two free, widely-used tools for public storytelling: StoryMaps JS for location-based narratives and Timeline JS for creating interactive chronologies. Participants will learn how journalists, educators, and humanists use these platforms to make complex stories interactive, dynamic, and memorable.",
        location: "Liberal Arts Building 205",
        type: "",
        instructor: "Dr. Andrew McSorley",
      },
      {
        time: "12:00 PM - 1:00 PM",
        title: "Lunch Break",
        description: "-",
        location: "",
        type: "",
        instructor: "-",
      },
      {
        time: "1:00 PM - 3:00 PM",
        title: "Personal Timeline Assignment",
        description:
          "Using Timeline JS, participants create an interactive timeline that places their own research topic or archival materials in historical context. This assignment reinforces both technical skills and the habit of thinking chronologically and contextually about evidence.",
        location: "Liberal Arts Building 205",
        type: "",
        instructor: "-",
      },
      {
        time: "3:00 PM - 4:30 PM",
        title: "Lab / Work Time / Timeline Submission",
        description: "-",
        location: "Liberal Arts Building 205",
        type: "",
        instructor: "-",
      },
      {
        time: "6:00 PM",
        title: "Group Dinner - Indian Delight",
        description: "Group dinner.",
        location: "Indian Delight, Hattiesburg, MS",
        locationUrl: "https://www.indiandelightms.com/",
        type: "meal",
        instructor: "-",
      },
    ],
  },
  {
    date: "2026-07-17",
    events: [
      {
        time: "9:00 AM - 12:00 PM",
        title: "Final Project Rehearsals and Feedback",
        description:
          "Structured rehearsal sessions where participants present their work-in-progress and receive constructive feedback from peers and instructors. This dedicated preparation time helps participants refine both the content of their projects and their confidence in presenting them.",
        location: "Liberal Arts Building 205",
        type: "",
        instructor: "-",
      },
      {
        time: "12:00 PM - 1:00 PM",
        title: "Lunch Break",
        description: "-",
        location: "",
        type: "",
        instructor: "-",
      },
      {
        time: "1:00 PM - 3:00 PM",
        title: "Final Project Rehearsals and Feedback",
        description: "-",
        location: "",
        type: "",
        instructor: "-",
      },
    ],
  },
  {
    date: "2026-07-18",
    events: [
      {
        time: "Weekend Option",
        title: "Movie Night / Board Games / Video Games in Union",
        description: "-",
        location: "",
        type: "",
        instructor: "-",
      },
    ],
  },
  {
    date: "2026-07-19",
    events: [
      {
        time: "Weekend Option",
        title: "Movie Night / Board Games / Video Games in Union",
        description: "-",
        location: "",
        type: "",
        instructor: "-",
      },
    ],
  },
  {
    date: "2026-07-20",
    events: [
      {
        time: "9:00 AM - 10:00 AM",
        title:
          '"Brunch Brag - Midtowner" from Audio, Video, or Timeline Assignments',
        description: "-",
        location: "Liberal Arts Building 205 - Break room",
        type: "",
        instructor: "-",
      },
      {
        time: "10:00 AM - 12:00 PM",
        title: "Lab Day: Focus on Final Project",
        description: "-",
        location: "Liberal Arts Building 205",
        type: "",
        instructor: "-",
      },
      {
        time: "12:00 PM - 1:00 PM",
        title: "Lunch Break",
        description: "-",
        location: "",
        type: "",
        instructor: "-",
      },
      {
        time: "1:00 PM - 4:30 PM",
        title: "Lab Day: Focus on Final Project (continued)",
        description: "-",
        location: "Liberal Arts Building 205",
        type: "",
        instructor: "-",
      },
      {
        time: "Submission",
        title: "Presentation Notes / Script and Final Program Details",
        description: "-",
        location: "Liberal Arts Building 205",
        type: "",
        instructor: "-",
      },
    ],
  },
  {
    date: "2026-07-21",
    events: [
      {
        time: "9:00 AM - 10:00 AM",
        title: "Introduce the Program Assessment",
        description: "-",
        location: "Liberal Arts Building 205",
        type: "",
        instructor: "-",
      },
      {
        time: "10:30 AM - 12:00 PM",
        title: "How to Bring DH into Your Next Step / Elevator Speech Workshop",
        description:
          "A practical workshop helping participants translate their DH experiences into clear, compelling language for academic applications, job interviews, and professional conversations. Participants will draft and practice a short `elevator speec` that communicates what they've done and why it matters.",
        location: "Liberal Arts Building 205",
        type: "",
        instructor: "-",
      },
      {
        time: "12:00 PM - 1:00 PM",
        title: "Lunch Break",
        description: "-",
        location: "",
        type: "",
        instructor: "-",
      },
      {
        time: "1:00 PM - 3:30 PM",
        title: "Resume and Cover Letter Assignment",
        description:
          " Guided work on updating resumes and drafting cover letters that highlight DH skills, research experience, and project-based learning. Participants will receive feedback and leave with polished professional documents tailored to their next steps.",
        location: "Liberal Arts Building 205",
        type: "",
        instructor: "-",
      },
      {
        time: "3:30 PM - 4:30 PM",
        title: "Lab / Work Time / Resume Submission",
        description: "-",
        location: "Liberal Arts Building 205",
        type: "",
        instructor: "-",
      },
    ],
  },
  {
    date: "2026-07-22",
    events: [
      {
        time: "9:00 AM - 10:30 AM",
        title: "Introduction to Coding Languages for DH (R, Python, Java)",
        description:
          "An accessible overview of programming languages commonly used in digital humanities work, with a focus on what each is good for and how to begin learning. No prior coding experience is assumed; the goal is to demystify code and open doors for further exploration.",
        location: "Liberal Arts Building 205",
        type: "",
        instructor: "Dr. Jose Martinez",
      },
      {
        time: "11:00 AM - 12:00 PM",
        title: "DIY Easy Coding Activity",
        description:
          "A fun, low-barrier hands-on activity where participants write and run simple code to accomplish a small humanistic task, such as processing a text or generating a visualization. This experience is designed to build confidence and curiosity rather than technical mastery.",
        location: "Liberal Arts Building 205",
        type: "",
        instructor: "-",
      },
      {
        time: "12:00 PM - 1:00 PM",
        title: "Lunch Break",
        description: "-",
        location: "",
        type: "",
        instructor: "-",
      },
      {
        time: "1:00 PM - 4:30 PM",
        title: "Lab Day: Focus on Final Project",
        description: "-",
        location: "Liberal Arts Building 205",
        type: "",
        instructor: "-",
      },
    ],
  },
  {
    date: "2026-07-23",
    events: [
      {
        time: "9:00 AM - 1:00 PM",
        title: "Final Project Presentations",
        description:
          "The culminating showcase of the residency, where participants present their completed digital humanities projects to an audience of peers, instructors, and invited guests. Each presentation reflects six weeks of archival research, tool-building, and scholarly thinking.",
        location: "",
        type: "",
        instructor: "-",
      },
      {
        time: "1:00 PM - 2:00 PM",
        title: "Lunch Break",
        description: "-",
        location: "",
        type: "",
        instructor: "-",
      },
      {
        time: "2:00 PM - 3:00 PM",
        title: "Group Thank-You Notes Activity",
        description: "-",
        location: "",
        type: "",
        instructor: "-",
      },
      {
        time: "5:00 PM onward",
        title: "Group Dinner Party",
        description: "-",
        location: "",
        type: "",
        instructor: "-",
      },
      {
        time: "6:00 PM",
        title: "Group Dinner - Hub Lanes Bowling Alley",
        description: "Group dinner.",
        location: "Hub Lanes Bowling Alley, Hattiesburg, MS",
        locationUrl:
          "https://www.google.com/maps/search/?api=1&query=Hub+Lanes+Bowling+Alley+Hattiesburg+MS",
        type: "meal",
        instructor: "-",
      },
    ],
  },
  {
    date: "2026-07-24",
    events: [
      {
        time: "9:00 AM - 10:00 AM",
        title: "Group Photo",
        description: "-",
        location: "",
        type: "",
        instructor: "-",
      },
      {
        time: "10:00 AM - 12:00 PM",
        title: "Letters of Achievement / Closing Ceremony",
        description:
          "A formal closing ceremony celebrating participants' accomplishments, including the presentation of letters of achievement recognizing their work over the six-week residency.",
        location: "",
        type: "",
        instructor: "-",
      },
      {
        time: "12:00 PM onward",
        title: "Send-Off! / Departures",
        description: "-",
        location: "",
        type: "",
        instructor: "-",
      },
    ],
  },
];
const typeStyles = {
  meal: {
    border: "#fb923c",
    bg: "#fff7ed",
    chipBg: "#ffedd5",
    chipColor: "#c2410c",
  },
  lab: {
    border: "#34d399",
    bg: "#ecfdf5",
    chipBg: "#d1fae5",
    chipColor: "#047857",
  },
  trip: {
    border: "#38bdf8",
    bg: "#f0f9ff",
    chipBg: "#e0f2fe",
    chipColor: "#0369a1",
  },
  workshop: {
    border: "#60a5fa",
    bg: "#eff6ff",
    chipBg: "#dbeafe",
    chipColor: "#1d4ed8",
  },
  project: {
    border: "#a78bfa",
    bg: "#f5f3ff",
    chipBg: "#ede9fe",
    chipColor: "#6d28d9",
  },
  presentation: {
    border: "#f472b6",
    bg: "#fdf2f8",
    chipBg: "#fce7f3",
    chipColor: "#be185d",
  },
  general: {
    border: "#cbd5e1",
    bg: "#ffffff",
    chipBg: "#f1f5f9",
    chipColor: "#475569",
  },
};

const cleanValue = (value) => {
  if (!value) return "";
  const trimmed = String(value).trim();
  return trimmed === "-" ? "" : trimmed;
};
const mapUrl = (query) =>
  `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(query)}`;

const getLocationUrl = (event) => {
  if (event.locationUrl) return event.locationUrl;
  if (event.location) return mapUrl(event.location);
  return "";
};

const inferEventType = (title = "") => {
  const t = title.toLowerCase();

  if (t.includes("lunch") || t.includes("dinner") || t.includes("brunch"))
    return "meal";
  if (
    t.includes("lab") ||
    t.includes("work time") ||
    t.includes("digitization") ||
    t.includes("digilab")
  )
    return "lab";
  if (
    t.includes("trip") ||
    t.includes("visit") ||
    t.includes("museum") ||
    t.includes("camp shelby")
  )
    return "trip";
  if (
    t.includes("presentation") ||
    t.includes("showcase") ||
    t.includes("ceremony") ||
    t.includes("rehearsal")
  )
    return "presentation";
  if (
    t.includes("project") ||
    t.includes("proposal") ||
    t.includes("assignment")
  )
    return "project";
  if (
    t.includes("introduction") ||
    t.includes("workshop") ||
    t.includes("guided") ||
    t.includes("qgis") ||
    t.includes("omeka")
  )
    return "workshop";

  return "general";
};

const getEventGraphic = (title = "") => {
  const t = String(title).toLowerCase();

  if (t.includes("lunch") || t.includes("dinner") || t.includes("brunch"))
    return lunchImg;
  if (t.includes("omeka")) return omekaImg;
  if (t.includes("arcgis")) return mapImg;
  if (t.includes("artificial intelligence") || t.includes("ai")) return aiImg;
  if (t.includes("twine")) return twineImg;
  if (t.includes("digitization") || t.includes("digilab"))
    return digitizationImg;
  if (
    t.includes("archives") ||
    t.includes("special collections") ||
    t.includes("selection of items")
  )
    return archiveImg;
  if (t.includes("audio") || t.includes("audacity")) return audioImg;
  if (
    t.includes("video creation") ||
    t.includes("video narratives") ||
    t.includes("canva")
  )
    return videoImg;
  if (t.includes("coding") || t.includes("python") || t.includes("java"))
    return codeImg;
  if (t.includes("proposal") || t.includes("assignment")) return proposalImg;
  if (
    t.includes("presentation") ||
    t.includes("showcase") ||
    t.includes("rehearsal") ||
    t.includes("ceremony")
  )
    return presentationImg;
  if (t.includes("trip")) return tripImg;
  if (t.includes("housing") || t.includes("check-in")) return housingImg;
  if (t.includes("tour")) return tourImg;
  if (t.includes("photo")) return photoImg;
  if (t.includes("thank-you")) return thankyouImg;
  if (t.includes("elevator")) return pitchImg;
  if (t.includes("movie night")) return funtimeImg;
  if (t.includes("send-off")) return sendoffImg;
  if (t.includes("day off")) return freeImg;
  if (t.includes("itech")) return itechImg;
  if (t.includes("research questions")) return researchImg;
  if (t.includes("research concepts") || t.includes("research time"))
    return researchconceptsImg;
  if (t.includes("q&a")) return qImg;
  if (t.includes("digital projects") || t.includes("meredith project"))
    return digitalImg;
  if (t.includes("qgis")) return qgisImg;
  if (t.includes("one-on-one")) return oneononeImg;
  if (t.includes("3d scanning")) return scanImg;
  if (t.includes("camp shelby")) return campImg;
  if (t.includes("digital scholarship")) return analyzeImg;
  if (t.includes("digital stories")) return digitalstoryImg;
  if (t.includes("timeline js")) return timelineImg;
  if (t.includes("pocket museum")) return pocketmuseumImg;
  if (t.includes("wordpress")) return wordpressImg;
  if (t.includes("lab")) return labImg;
  if (t.includes("orientation")) return orientationImg;
  if (t.includes("museums")) return museumImg;
  if (t.includes("free time")) return freetimeImg;
  if (t.includes("mdl")) return mdlImg;
  if (t.includes("july 4th")) return julyImg;
  if (t.includes("review of lib")) return reviewImg;
  if (t.includes("discussion")) return discussionImg;

  return defaultImg;
};

const ScheduleSummer2026 = () => {
  const [selectedDate, setSelectedDate] = useState(scheduleData[0].date);
  const [calendarMonth, setCalendarMonth] = useState(dayjs("2026-06-01"));
  const [selectedEvent, setSelectedEvent] = useState(null);
  const dayRefs = useRef({});

  const daysWithEvents = useMemo(
    () => new Set(scheduleData.map((d) => d.date)),
    []
  );

  const scrollToDay = (date) => {
    setSelectedDate(date);
    setCalendarMonth(dayjs(date).startOf("month"));

    setTimeout(() => {
      const target = dayRefs.current[date];
      if (!target) return;

      const y = target.getBoundingClientRect().top + window.pageYOffset - 180;

      window.scrollTo({
        top: y,
        behavior: "smooth",
      });
    }, 80);
  };
  useEffect(() => {
    document.title = "Summer Residency 2026 Schedule - MS Digital Hub";
  }, []);
  return (
    <Box
      sx={{
        bgcolor: "",
        minHeight: "100vh",
        py: { xs: 2, md: 4 },
        overflowX: "clip",
      }}
    >
      {" "}
      <Container
        maxWidth="xl"
        sx={{
          px: { xs: 1.5, sm: 2.5, md: 4 },
          overflow: "visible",
        }}
      >
        {" "}
        <Box
          sx={{
            display: { xs: "flex", md: "grid" },
            flexDirection: { xs: "column", md: "unset" },
            gridTemplateColumns: { md: "280px minmax(0, 1fr)" },
            gap: { xs: 3, md: 4 },
            alignItems: "start",
            maxWidth: "100%",
            overflow: "visible",
          }}
        >
          {" "}
          <Box
            sx={{
              gridColumn: { md: "1 / -1" },
              display: "grid",
              gridTemplateColumns: { xs: "1fr", md: "1fr auto 1fr" },
              alignItems: "center",
              gap: 2,
              mb: { xs: 2, md: 4 },
            }}
          >
            {/* left spacer */}
            <Box sx={{ display: { xs: "none", md: "block" } }} />

            {/* centered title */}
            <Box sx={{ textAlign: "center" }}>
              <Typography
                variant="h4"
                sx={{
                  marginBottom: { xs: "15px", md: "30px" },
                  textAlign: "center",
                  fontWeight: 500,

                  paddingBottom: "5px",
                  borderBottom: "2px solid #FFD700",
                }}
              >
                Summer Residency 2026 Schedule
              </Typography>
            </Box>

            {/* right button */}
            <Box
              sx={{
                display: "flex",
                justifyContent: { xs: "center", md: "flex-end" },
              }}
            >
              <Button
                startIcon={<TodayIcon />}
                variant="contained"
                onClick={() => {
                  setCalendarMonth(dayjs("2026-06-01"));
                  scrollToDay(scheduleData[0].date);
                }}
                sx={{
                  borderRadius: 999,
                  textTransform: "none",
                  px: 2.5,
                  fontWeight: 700,
                }}
              >
                Back to first day
              </Button>
            </Box>
          </Box>
          <Box
            sx={{
              width: "100%",
              maxWidth: { xs: "100%", md: 280 },
              position: { xs: "relative", md: "sticky" },
              top: { md: 180 },
              alignSelf: "start",
              zIndex: 10,
              height: "fit-content",
            }}
          >
            {" "}
            <CalendarWidget
              month={calendarMonth}
              selectedDate={selectedDate}
              daysWithEvents={daysWithEvents}
              onSelectDate={scrollToDay}
              onPrevMonth={() => setCalendarMonth(dayjs("2026-06-01"))}
              onNextMonth={() => setCalendarMonth(dayjs("2026-07-01"))}
            />{" "}
            <Paper
              sx={{
                mt: 2,
                p: { xs: 2, md: 3 },
                borderRadius: 4,
                width: "100%",
                overflow: "hidden",
              }}
            >
              {" "}
              <Box sx={{ display: "flex", gap: 1.5, alignItems: "center" }}>
                <EventIcon color="primary" />{" "}
                <Typography variant="subtitle2" fontWeight={800}>
                  Summer Residency 2026{" "}
                </Typography>{" "}
              </Box>{" "}
              <Typography
                sx={{
                  mt: 1,
                  fontSize: "0.85rem",
                  lineHeight: 1.6,
                  color: "#64748b",
                }}
              >
                Use the calendar to jump between workshop dates.{" "}
              </Typography>{" "}
            </Paper>{" "}
          </Box>{" "}
          <Box sx={{ minWidth: 0, maxWidth: "100%" }}>
            {" "}
            {scheduleData.map((day, index) => (
              <DaySection
                key={day.date}
                day={day}
                index={index}
                onCardClick={setSelectedEvent}
                refCallback={(el) => {
                  dayRefs.current[day.date] = el;
                }}
              />
            ))}{" "}
          </Box>{" "}
        </Box>{" "}
      </Container>{" "}
      <EventDetailsDialog
        event={selectedEvent}
        onClose={() => setSelectedEvent(null)}
      />{" "}
    </Box>
  );
};

const CalendarWidget = ({
  month,
  selectedDate,
  daysWithEvents,
  onSelectDate,
  onPrevMonth,
  onNextMonth,
}) => {
  const isJune = month.format("YYYY-MM") === "2026-06";
  const isJuly = month.format("YYYY-MM") === "2026-07";

  const startOfMonth = month.startOf("month");
  const endOfMonth = month.endOf("month");
  const startDay = startOfMonth.day();
  const totalDays = endOfMonth.date();

  const cells = [];
  for (let i = 0; i < startDay; i++) cells.push(null);
  for (let day = 1; day <= totalDays; day++) cells.push(month.date(day));

  return (
    <Paper
      sx={{
        p: { xs: 2, md: 2.5 },
        borderRadius: 4,
        width: "100%",
        maxWidth: { xs: "100%", md: 280 },
        overflow: "hidden",
      }}
    >
      {" "}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          mb: 2,
        }}
      >
        {" "}
        <IconButton size="small" onClick={onPrevMonth} disabled={isJune}>
          <ChevronLeftIcon />{" "}
        </IconButton>{" "}
        <Typography
          variant="h6"
          fontWeight={800}
          sx={{
            fontSize: { xs: "1rem", md: "1.25rem" },
            letterSpacing: "-0.02em",
          }}
        >
          {month.format("MMMM YYYY")}{" "}
        </Typography>{" "}
        <IconButton size="small" onClick={onNextMonth} disabled={isJuly}>
          <ChevronRightIcon />{" "}
        </IconButton>{" "}
      </Box>{" "}
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "repeat(7, 1fr)",
          gap: 0.5,
          mb: 1,
        }}
      >
        {" "}
        {["S", "M", "T", "W", "T", "F", "S"].map((d, i) => (
          <Typography
            key={`${d}-${i}`}
            sx={{
              fontSize: "0.72rem",
              fontWeight: 800,
              textAlign: "center",
              color: "#64748b",
              letterSpacing: "0.04em",
            }}
          >
            {d}{" "}
          </Typography>
        ))}{" "}
      </Box>{" "}
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "repeat(7, 1fr)",
          gap: 0.5,
        }}
      >
        {" "}
        {cells.map((date, idx) => {
          if (!date) return <Box key={`empty-${idx}`} sx={{ height: 32 }} />;

          const dateKey = date.format("YYYY-MM-DD");
          const hasEvent = daysWithEvents.has(dateKey);
          const active = selectedDate === dateKey;

          return (
            <Box
              key={dateKey}
              onClick={() => hasEvent && onSelectDate(dateKey)}
              sx={{
                height: 32,
                width: 32,
                mx: "auto",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: hasEvent ? "pointer" : "not-allowed",
                bgcolor: active
                  ? "#2563eb"
                  : hasEvent
                    ? "#eff6ff"
                    : "transparent",
                color: active ? "#fff" : hasEvent ? "#1e3a8a" : "#cbd5e1",
                border: hasEvent && !active ? "1px solid #bfdbfe" : "none",
                fontSize: "0.82rem",
                fontWeight: 800,
                opacity: hasEvent ? 1 : 0.45,
              }}
            >
              {date.date()}{" "}
            </Box>
          );
        })}{" "}
      </Box>{" "}
    </Paper>
  );
};

const DaySection = ({ day, index, refCallback, onCardClick }) => {
  const sliderRef = useRef(null);
  const date = dayjs(day.date);

  const settings = {
    dots: true,
    infinite: false,
    speed: 400,
    slidesToShow: Math.min(3, day.events.length),
    slidesToScroll: 1,
    arrows: false,
    swipeToSlide: true,
    adaptiveHeight: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: { slidesToShow: Math.min(2, day.events.length) },
      },
      { breakpoint: 700, settings: { slidesToShow: 1, centerMode: false } },
    ],
  };

  return (
    <Box
      ref={refCallback}
      sx={{
        scrollMarginTop: { xs: "100px", md: "180px" },
        mb: { xs: 4, md: 5 },
        borderBottom: "1px solid #e5e7eb",
        pb: { xs: 4, md: 5 },
        overflow: "hidden",
      }}
    >
      {" "}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: { xs: "flex-start", sm: "center" },
          flexDirection: { xs: "column", sm: "row" },
          gap: 1,
          mb: 1,
        }}
      >
        {" "}
        <Typography
          variant="h6"
          fontWeight={800}
          sx={{
            fontSize: { xs: "1rem", md: "1.25rem" },
            letterSpacing: "-0.02em",
            lineHeight: 1.2,
            color: "#0f172a",
          }}
        >
          {index + 1}. {date.format("MMMM D, YYYY")} ({date.format("dddd")}
          ){" "}
        </Typography>{" "}
        {day.events.length > 1 && (
          <Box sx={{ display: "flex", gap: 1 }}>
            {" "}
            <IconButton
              onClick={() => sliderRef.current?.slickPrev()}
              sx={{ bgcolor: "#fff", border: "1px solid #e5e7eb" }}
            >
              <ChevronLeftIcon />{" "}
            </IconButton>{" "}
            <IconButton
              onClick={() => sliderRef.current?.slickNext()}
              sx={{ bgcolor: "#fff", border: "1px solid #e5e7eb" }}
            >
              <ChevronRightIcon />{" "}
            </IconButton>{" "}
          </Box>
        )}{" "}
      </Box>{" "}
      {day.events.length > 1 && (
        <Typography
          sx={{
            display: "block",
            mb: 1.5,
            fontSize: "0.72rem",
            fontWeight: 800,
            letterSpacing: "0.08em",
            textTransform: "uppercase",
            color: "#64748b",
          }}
        >
          Swipe or use arrows to view more sessions →{" "}
        </Typography>
      )}{" "}
      <Box
        sx={{
          width: "100%",
          overflow: "hidden",
          "& .slick-list": { overflow: "hidden", margin: "0 -8px" },
          "& .slick-track": { display: "flex", alignItems: "stretch" },
          "& .slick-slide > div": { height: "100%" },
          "& .slick-dots": { bottom: -22 },
        }}
      >
        {" "}
        <Slider ref={sliderRef} {...settings}>
          {" "}
          {day.events.map((event, idx) => (
            <Box key={`${day.date}-${idx}`} sx={{ px: 1, pb: 3 }}>
              {" "}
              <EventCard
                event={event}
                onClick={() => onCardClick(event)}
              />{" "}
            </Box>
          ))}{" "}
        </Slider>{" "}
      </Box>{" "}
    </Box>
  );
};

const EventCard = ({ event, onClick }) => {
  const eventType = event.type || inferEventType(event.title);
  const style = typeStyles[eventType] || typeStyles.general;
  const graphic = getEventGraphic(event.title);
  const instructor = cleanValue(event.instructor);
  const location = cleanValue(event.location);

  return (
    <Paper
      onClick={onClick}
      sx={{
        minHeight: { xs: 310, md: 315 },
        height: "100%",
        p: { xs: 2, md: 2.5 },
        borderRadius: 4,
        border: `2px solid ${style.border}`,
        bgcolor: style.bg,
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        overflow: "hidden",
        position: "relative",
        cursor: "pointer",
        transition: "all 0.2s ease",
        "&:hover": {
          transform: "translateY(-4px)",
          boxShadow: "0 16px 32px rgba(15, 23, 42, 0.14)",
        },
      }}
    >
      {" "}
      <Box
        sx={{
          position: "absolute",
          bottom: -32,
          right: -28,
          width: { xs: 135, md: 155 },
          height: { xs: 135, md: 155 },
          borderRadius: "50%",
          bgcolor: style.chipBg,
          zIndex: 0,
          overflow: "hidden",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          border: `1px solid ${style.border}`,
        }}
      >
        {" "}
        <Box
          component="img"
          src={graphic}
          alt=""
          sx={{
            width: { xs: 90, md: 105 },
            height: { xs: 90, md: 105 },
            borderRadius: "50%",
            objectFit: "cover",
            opacity: 0.65,
            filter: "saturate(1.1) contrast(1.08)",
          }}
        />{" "}
      </Box>{" "}
      <Box sx={{ position: "relative", zIndex: 2 }}>
        {" "}
        <Typography
          sx={{
            fontSize: "0.85rem",
            fontWeight: 800,
            color: style.chipColor,
          }}
        >
          {event.time}{" "}
        </Typography>{" "}
        <Typography
          variant="h6"
          fontWeight={800}
          sx={{
            mt: 2,
            pr: { xs: 2, md: 4 },
            fontSize: { xs: "1rem", md: "1.25rem" },
            lineHeight: 1.15,
            letterSpacing: "-0.02em",
            color: "#0f172a",
          }}
        >
          {event.title}{" "}
        </Typography>{" "}
        {instructor && (
          <Typography
            sx={{
              mt: 1,
              fontSize: "0.86rem",
              lineHeight: 1.5,
              color: "#64748b",
            }}
          >
            Guest speaker — {instructor}{" "}
          </Typography>
        )}{" "}
        {location && (
          <Typography
            component="a"
            href={getLocationUrl(event)}
            target="_blank"
            rel="noopener noreferrer"
            onClick={(e) => e.stopPropagation()}
            sx={{
              mt: 0.5,
              fontSize: "0.86rem",
              lineHeight: 1.5,
              color: "#2563eb",
              textDecoration: "none",
              "&:hover": { textDecoration: "underline" },
            }}
          >
            📍 {location}
          </Typography>
        )}
      </Box>{" "}
      <Box sx={{ position: "relative", zIndex: 2 }}>
        {" "}
        <Typography
          sx={{
            display: "block",
            mb: 1,
            fontSize: "0.72rem",
            fontWeight: 800,
            letterSpacing: "0.08em",
            textTransform: "uppercase",
            color: style.chipColor,
          }}
        >
          Click to view details{" "}
        </Typography>{" "}
        <Chip
          label={eventType}
          size="small"
          sx={{
            bgcolor: style.chipBg,
            color: style.chipColor,
            fontWeight: 800,
            textTransform: "capitalize",
          }}
        />{" "}
      </Box>{" "}
    </Paper>
  );
};

const EventDetailsDialog = ({ event, onClose }) => {
  if (!event) return null;

  const eventType = event.type || inferEventType(event.title);
  const style = typeStyles[eventType] || typeStyles.general;
  const graphic = getEventGraphic(event.title);
  const description = cleanValue(event.description);
  const instructor = cleanValue(event.instructor);
  const location = cleanValue(event.location);

  return (
    <Dialog
      open={Boolean(event)}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      fullScreen={window.innerWidth < 600}
      BackdropProps={{
        sx: {
          backdropFilter: "blur(6px)",
          backgroundColor: "rgba(15, 23, 42, 0.35)",
        },
      }}
      PaperProps={{
        sx: {
          borderRadius: { xs: 0, sm: 4 },
          overflow: "hidden",
        },
      }}
    >
      {" "}
      <DialogContent sx={{ p: 0, position: "relative" }}>
        {" "}
        <IconButton
          onClick={onClose}
          sx={{
            position: "absolute",
            top: 12,
            right: 12,
            zIndex: 3,
            bgcolor: "#fff",
            "&:hover": { bgcolor: "#f1f5f9" },
          }}
        >
          <CloseIcon />{" "}
        </IconButton>{" "}
        <Box
          sx={{
            p: { xs: 3, md: 4 },
            bgcolor: style.bg,
            borderTop: `6px solid ${style.border}`,
            position: "relative",
            overflow: "hidden",
          }}
        >
          {" "}
          <Box
            component="img"
            src={graphic}
            alt=""
            sx={{
              position: "absolute",
              right: -25,
              bottom: -25,
              width: { xs: 140, md: 180 },
              height: { xs: 140, md: 180 },
              borderRadius: "50%",
              objectFit: "cover",
              opacity: 0.18,
            }}
          />{" "}
          <Box sx={{ position: "relative", zIndex: 2 }}>
            {" "}
            <Chip
              label={eventType}
              size="small"
              sx={{
                bgcolor: style.chipBg,
                color: style.chipColor,
                fontWeight: 800,
                textTransform: "capitalize",
                mb: 2,
              }}
            />{" "}
            <Typography
              sx={{
                fontSize: "0.88rem",
                fontWeight: 800,
                color: style.chipColor,
              }}
            >
              {event.time || "Time TBD"}{" "}
            </Typography>{" "}
            <Typography
              variant="h5"
              fontWeight={800}
              sx={{
                mt: 1.5,
                fontSize: { xs: "1.4rem", md: "1.5rem" },
                letterSpacing: "-0.03em",
                lineHeight: 1.15,
                color: "#0f172a",
              }}
            >
              {event.title}{" "}
            </Typography>{" "}
            {description && (
              <Box sx={{ mt: 2 }}>
                <Typography
                  sx={{
                    fontSize: "0.95rem",
                    fontWeight: 800,
                    color: "#0f172a",
                    mb: 1,
                  }}
                >
                  What We'll Explore
                </Typography>

                {description
                  .replace("What We'll Explore", "")
                  .split("|")
                  .map((item, index) => {
                    const cleanItem = item.trim();
                    if (!cleanItem) return null;

                    return (
                      <Typography
                        key={index}
                        sx={{
                          fontSize: "0.95rem",
                          lineHeight: 1.8,
                          color: "#475569",
                          mb: 0.6,
                        }}
                      >
                        {cleanItem}
                      </Typography>
                    );
                  })}
              </Box>
            )}
            <Box sx={{ mt: 3 }}>
              {" "}
              {instructor && (
                <Typography
                  sx={{
                    display: "flex",
                    gap: 1,
                    mb: 1,
                    fontSize: "0.9rem",
                    color: "#475569",
                  }}
                >
                  <PersonIcon fontSize="small" />
                  <b>Instructor:</b> {instructor}{" "}
                </Typography>
              )}{" "}
              {location && (
                <Typography
                  component="a"
                  href={getLocationUrl(event)}
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{
                    display: "flex",
                    gap: 1,
                    fontSize: "0.9rem",
                    color: "#2563eb",
                    textDecoration: "none",
                    "&:hover": { textDecoration: "underline" },
                  }}
                >
                  <LocationOnIcon fontSize="small" />
                  <b>Location:</b> {location}
                </Typography>
              )}
            </Box>{" "}
          </Box>{" "}
        </Box>{" "}
      </DialogContent>{" "}
    </Dialog>
  );
};

export default ScheduleSummer2026;
